import { render, staticRenderFns } from "./ModalTutorial.vue?vue&type=template&id=0945f9f4&scoped=true&"
import script from "./ModalTutorial.vue?vue&type=script&lang=js&"
export * from "./ModalTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutorial.vue?vue&type=style&index=0&id=0945f9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945f9f4",
  null
  
)

export default component.exports